import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'

import Field from '../../../../components/Form/Field'
import Form from '../../../../components/Form'

import {
  initialValues,
  transformValuesToBE,
  USER_FIRST_NAME,
  USER_LAST_NAME,
  USER_PASSWORD,
  validationSchema
} from '../fields'

import { acceptBetaInvite, clearAcceptBetaInvite } from '../../../../modules/actions/team'
import {
  acceptBetaInviteErrorSelector,
  acceptBetaInviteIsLoadingSelector,
  betaInviteWasAcceptedSelector
} from '../../../../modules/selectors/team'

const AcceptBetaInviteForm = ({ token, userCountry }) => {
  const dispatch = useDispatch()

  const inviteWasAccepted = useSelector(betaInviteWasAcceptedSelector)

  const onSubmit = useCallback(
    values => {
      const transformedData = transformValuesToBE(values, userCountry, token)
      dispatch(acceptBetaInvite(transformedData, true))
    },
    [dispatch, token, userCountry]
  )

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  })

  useEffect(() => {
    return () => {
      dispatch(clearAcceptBetaInvite())
    }
  }, [dispatch])

  return (
    <Form
      formik={formik}
      method="post"
      successSubmit={inviteWasAccepted}
      isLoadingSelector={acceptBetaInviteIsLoadingSelector}
      errorSelector={acceptBetaInviteErrorSelector}
      submitText="Sign Up"
    >
      <Field formik={formik} id={USER_FIRST_NAME} name={USER_FIRST_NAME} placeholder="First name" />
      <Field formik={formik} id={USER_LAST_NAME} name={USER_LAST_NAME} placeholder="Last name" autoComplete="off" />
      <Field
        formik={formik}
        type="password"
        id={USER_PASSWORD}
        name={USER_PASSWORD}
        placeholder="New Password"
        autoComplete="new-password"
      />
    </Form>
  )
}

export default AcceptBetaInviteForm
